"use client";

import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  Button,
} from "@oreme/ui";
import { useAtom } from "jotai";
import { Tag, ChevronRight } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { DevicesTagSuggest, DevicesTagSelect } from "@/components";
import { sidebarFilterTagVisibilityAtom } from "@/store/devices";

function DevicesSidebarFilterTag(): ReactElement {
  const t = useTranslations("devices.SidebarFilterTag");
  const [isVisible, toggleVisibility] = useAtom(sidebarFilterTagVisibilityAtom);

  return (
    <Collapsible
      className="group/collapsible p-0 border rounded-lg"
      open={isVisible}
      onOpenChange={toggleVisibility}
    >
      <div key="tag">
        <CollapsibleTrigger asChild>
          <Button
            variant="ghost"
            className="flex flex-row gap-1 border-0 bg-transparent"
            onClick={() => toggleVisibility()}
            asChild
          >
            <span className="flex flex-row gap-1">
              <Tag />
              <span>{t("tag")}</span>
              <ChevronRight
                className={`ml-auto h-4 w-4 transition-transform ${isVisible ? "rotate-90" : ""}`}
              />
            </span>
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="flex flex-col gap-3 p-2 rounded-b-lg">
          <DevicesTagSelect />
          <hr />
          <DevicesTagSuggest />
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}

export { DevicesSidebarFilterTag };
